<template>
  <v-container class="content ma2">
    <div data-aos="fadeInUp">
      <div class="display-2 text--center">ABOUT US</div>
      <div class="grey--text subheading">The brain of the operation</div>
    </div>

    <blockquote class="blockquote">We are driven, industry trained, safety oriented, with a focus on growth and empowering our employees to suceeded in life.</blockquote>
    <v-layout row wrap data-aos="fadeInUp">
      <v-flex xs12 md6>
        <v-card class="ma-2">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">OUR VISION</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <span>To become a leader in providing safe, and cost effective hydrovac services in Ontario.</span>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md6>
        <v-card class="ma-2">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">MISSION STATEMENT</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <span>Safety is of the utmost importance to Hydrovac King Ltd.  We strive to protect our employees, client's property and the envrionment.  We love our planet and we truly believe that we must strive to protect it to the best of our ability.  We will not compromise the health and safety of any individual with our services.</span>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md6>
        <v-card class="ma-2">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">SAFETY</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <span>Hydrovac King Ltd understands the importance of providing quilified and certified operators.  All of our employees are trained and educated to meet the industries safety standards.  We always keep current with regulations and believe in continuous education in our industry.</span>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md6>
        <v-card class="ma-2">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">QUALITY</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <span>At Hydrovac King Ltd, we offer highly qualified operators with many years of experience to meet the needs of our customers and provide quality serivces with safety being our number one priority.</span>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>